import { useContext, useEffect, useState } from "react";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/InactiveDevicesReports/NewInactiveDevicesReport.css";
import { thingsBoardMicroserviceUrl } from "../../../../microservices/thingsboard_microservice";
import { InactiveDevicesReportContext } from "./InactiveDevicesReportProvider";
import { AppContext } from "../../../AppProvider";
const NewInactiveDevicesReportMessageBox = ({showNewInactiveDevicesReportMessageBox,setShowNewInactiveDevicesReportMessageBox,title,message}) =>{
    if(!showNewInactiveDevicesReportMessageBox) return null;
    return(
        <div className="new-inactive-devices-report-message-box-container">
            <div className="new-inactive-devices-report-message-box-header">
                <h3>{title}</h3>
                <p onClick={() => setShowNewInactiveDevicesReportMessageBox(false)}>&#10006;</p>
            </div>
            <div className="new-inactive-devices-report-message-box-body">
                <p>{message}</p>
            </div>
            <div className="new-inactive-devices-report-message-box-buttons-container">
                <button onClick={() => setShowNewInactiveDevicesReportMessageBox(false)}>Okay</button>
            </div>
        </div>
    );
};
const NewInactiveDevicesReportDetailsTab = ({showNewInactiveDevicesReportDetailsTab,newInactiveDevicesReportName,setNewInactiveDevicesReportName}) =>{
    if(!showNewInactiveDevicesReportDetailsTab) return null;
    return(
        <div className="new-inactive-devices-report-details-tab-container">
            <p>Name</p>
            <input
                placeholder="Enter the name of the report"
                value={newInactiveDevicesReportName}
                onChange={(e) => setNewInactiveDevicesReportName(e.target.value)}/>
        </div>
    );
};
const NewInactiveDevicesReportDevicesTab = ({user,logout,deviceEntries,setDeviceEntries,selectedServerUrl,showNewInactiveDevicesReportDevicesTab}) =>{
    const [showNewInactiveDevicesReportDevicesBrowser,setShowNewInactiveDevicesReportDevicesBrowser] = useState(false);
    if(!showNewInactiveDevicesReportDevicesTab) return null;
    return(
        <div className="new-inactive-devices-report-devices-tab-container">
            <div className="new-inactive-devices-report-devices-controls-container">
                <p>Devices</p>
                <button
                    style={{display:`${showNewInactiveDevicesReportDevicesBrowser? 'none':'inline-block'}`}}
                    onClick={() => setShowNewInactiveDevicesReportDevicesBrowser(true)}>Add</button>
            </div>
            {deviceEntries.length === 0? (
                <div style={{display:`${showNewInactiveDevicesReportDevicesBrowser? 'none':'block'}`}} className="new-inactive-devices-report-devices-empty-table-container">
                    <h4>Report has no devices</h4>
                    <p>Your report does not contain any devices. Please add at least one device.</p>
                </div>
            ):(
                <div className="new-inactive-devices-report-devices-table-container">
                    <table>
                        <thead>
                            <tr id="new-inactive-devices-report-devices-table-header-row">
                                <th style={{width:'40%'}}>Name</th>
                                <th style={{width:'25%'}}>Date added</th>
                                <th style={{width:'25%'}}>Time added</th>
                                <th style={{width:'10%'}}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {deviceEntries.length > 0 && deviceEntries.map((deviceEntry) =>(
                                <tr key={deviceEntry.id}>
                                    <td>{deviceEntry.name}</td>
                                    <td>{deviceEntry.dateAdded}</td>
                                    <td>{deviceEntry.timeAdded}</td>
                                    <td>
                                        <img
                                            onClick={() =>{
                                                const updatedDeviceEntries = deviceEntries.filter( entry => entry.id !== deviceEntry.id);
                                                setDeviceEntries(updatedDeviceEntries);
                                            }}
                                            src={`${process.env.PUBLIC_URL}/images/delete-icon.png`}/>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            <NewInactiveDevicesReportDevicesBrowser
                user={user}
                logout={logout}
                deviceEntries={deviceEntries}
                setDeviceEntries={setDeviceEntries}
                selectedServerUrl={selectedServerUrl}
                showNewInactiveDevicesReportDevicesBrowser={showNewInactiveDevicesReportDevicesBrowser}
                setShowNewInactiveDevicesReportDevicesBrowser={setShowNewInactiveDevicesReportDevicesBrowser}
            />
        </div>
    );
};
const NewInactiveDevicesReportDevicesBrowser = ({
        deviceEntries,
        setDeviceEntries,
        showNewInactiveDevicesReportDevicesBrowser,
        setShowNewInactiveDevicesReportDevicesBrowser
    }) =>{
    const {user,logout} = useContext(AppContext);
    const {selectedTenantAdminProfile} = useContext(InactiveDevicesReportContext);
    const [devicesSummary,setDevicesSummary] = useState([]);
    const [selectedDeviceId,setSelectedDeviceId] = useState('');
    const fetchDevicesSummary = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/devices?limit=50`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user?.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setDevicesSummary(responseData);
            }
            else if(response.status === 401) logout();
            else throw new Error(`response code: ${response.status}`);
        }
        catch(error){
            console.error(error);
        }
    };
    useEffect(() =>{
        if(showNewInactiveDevicesReportDevicesBrowser){
            fetchDevicesSummary();
            setSelectedDeviceId('');
        }
    },[showNewInactiveDevicesReportDevicesBrowser]);
    if(!showNewInactiveDevicesReportDevicesBrowser) return null;
    return(
        <div className="new-inactive-devices-report-devices-browser-container">
            <div className="new-inactive-devices-report-devices-browser-header">
                <h3>Add device</h3>
                <p onClick={() => setShowNewInactiveDevicesReportDevicesBrowser(false)}>&#10006;</p>
            </div>
            <div className="new-inactive-devices-report-devices-browser-body">
                <select value={selectedDeviceId} onChange={(e) => setSelectedDeviceId(e.target.value)}>
                    <option value='' disabled>Select device</option>
                    {devicesSummary && devicesSummary.length > 0 && devicesSummary.map(deviceSummary =>{
                        const isDeviceInEntries = deviceEntries.some(entry => entry.id === deviceSummary.id);
                        if(isDeviceInEntries) return null;
                        return(<option key={deviceSummary.name} value={deviceSummary.id}>{deviceSummary.name}</option>);
                    })}
                </select>
            </div>
            <div className="new-inactive-devices-report-devices-browser-add-button-container">
                <button onClick={() =>{
                    if(selectedDeviceId === '') return;
                    const selectedDevice = devicesSummary.find(device => device.id === selectedDeviceId);
                    if(!selectedDevice) return;
                    const addedDate = new Date();
                    const day = addedDate.getDate();
                    const month = addedDate.getMonth() + 1;
                    const year = addedDate.getFullYear();
                    const dateAdded = `${day > 9? '':'0'}${day}-${month > 9? '':'0'}${month}-${year}`;
                    const timeAdded = addedDate.toLocaleTimeString('en-GB');
                    setDeviceEntries((prevDeviceEntries) => [...prevDeviceEntries,{
                        id:selectedDevice.id,
                        name:selectedDevice.name,
                        dateAdded:dateAdded,
                        timeAdded:timeAdded
                    }]);
                    setShowNewInactiveDevicesReportDevicesBrowser(false);
                }}>Add</button>
            </div>
        </div>
    );
};
const NewInactiveDevicesReportScheduleTab = ({scheduleEntries,setScheduleEntries,showNewInactiveDevicesReportScheduleTab}) =>{
    const [showNewReportScheduleEntry,setShowNewReportScheduleEntry] = useState(false);
    if(!showNewInactiveDevicesReportScheduleTab) return null;
    return(
        <div className="new-inactive-devices-report-schedule-tab-container">
            <div className="new-inactive-devices-report-schedule-controls-container">
                <p>Schedule</p>
                <button onClick={() => setShowNewReportScheduleEntry(true)}>Add</button>
            </div>
            {scheduleEntries.length === 0? (
                <div style={{display:`${showNewReportScheduleEntry?'none':'block'}`}} className="new-inactive-devices-report-schedule-entries-empty-table-container">
                    <h4>Report has no schedules</h4>
                    <p>Your report does not contain any schedules. Please add at least one schedule.</p>
                </div>
            ):(
                <div className="new-inactive-devices-report-schedule-entries-table-container">
                    <table>
                        <thead>
                            <tr id="new-inactive-devices-report-schedule-entries-table-header-row">
                                <th>Frequency</th>
                                <th>Time</th>
                                <th>Inactivity threshold</th>
                                <th style={{textAlign:'center'}}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {scheduleEntries && scheduleEntries.length > 0 && scheduleEntries.map((scheduleEntry,scheduleEntryIndex) =>(
                                <tr key={scheduleEntryIndex}>
                                    <td>{scheduleEntry.frequency}</td>
                                    <td>{scheduleEntry.time}</td>
                                    <td>{scheduleEntry.inactivityThreshold? `${
                                        scheduleEntry.inactivityThreshold === 0.5? 
                                        '30 minutes':`${scheduleEntry.inactivityThreshold} Hour${scheduleEntry.inactivityThreshold === 1? '':'s'}`
                                    }`:''}</td>
                                    <td>
                                        <div>
                                            <div>
                                                <img src={`${process.env.PUBLIC_URL}/images/edit-icon.png`} title="Edit schedule entry"/>
                                            </div>
                                            <div onClick={() =>{
                                                const updatedScheduleEntries = scheduleEntries.filter((_,index) => index !== scheduleEntryIndex);
                                                setScheduleEntries(updatedScheduleEntries);
                                            }}>
                                                <img src={`${process.env.PUBLIC_URL}/images/delete-icon.png`} title="Delete shedule entry"/>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            <NewReportScheduleEntry
                showNewReportScheduleEntry={showNewReportScheduleEntry}
                setShowNewReportScheduleEntry={setShowNewReportScheduleEntry}
                setScheduleEntries={setScheduleEntries}
            />
        </div>
    );
};
const NewReportScheduleEntry = ({showNewReportScheduleEntry,setShowNewReportScheduleEntry,setScheduleEntries}) =>{
    const [scheduleFrequency,setScheduleFrequency] = useState('Every day');
    const [scheduleTime,setScheduleTime] = useState('07:00');
    const [inactivityThreshold,setInactivityThreshold] = useState(1);
    useEffect(() => {
        if(showNewReportScheduleEntry){
            setScheduleFrequency('Every day');
            setScheduleTime('07:00');
            setInactivityThreshold(1);
        }
    },[showNewReportScheduleEntry]);
    if(!showNewReportScheduleEntry) return null;
    return(
        <div className="new-report-schedule-entry-container">
            <div className="new-report-schedule-entry-header">
                <h4>Add schedule</h4>
                <p onClick={() => setShowNewReportScheduleEntry(false)}>&#10006;</p>
            </div>
            <div className="new-report-schedule-frequency-entry-container">
                <p>Frequency</p>
                <select value={scheduleFrequency} onChange={(e) => setScheduleFrequency(e.target.value)}>
                    <option value='Every day'>Every day</option>
                    <option value='Every Monday'>Every Monday</option>
                    <option value='Every Tuesday'>Every Tuesday</option>
                    <option value='Every Wednesday'>Every Wednesday</option>
                    <option value='Every Thursday'>Every Thursday</option>
                    <option value='Every Friday'>Every Friday</option>
                    <option value='Every Saturday'>Every Saturday</option>
                    <option value='Every Sunday'>Every Sunday</option>
                </select>
            </div>
            <div className="new-report-schedule-time-entry-container">
                <p>Time</p>
                <input value={scheduleTime} type="time" onChange={(e) => setScheduleTime(e.target.value)}/>
            </div>
            <div className="new-report-schedule-inactivity-threshold-entry-container">
                <p>Inactivity threshold</p>
                <select value={inactivityThreshold} onChange={(e) => setInactivityThreshold(e.target.value)}>
                    <option value={0.5}>30 Minutes</option>
                    <option value={1}>1 Hour</option>
                    <option value={2}>2 Hours</option>
                    <option value={3}>3 Hours</option>
                    <option value={4}>4 Hours</option>
                    <option value={5}>5 Hours</option>
                    <option value={6}>6 Hours</option>
                    <option value={7}>7 Hours</option>
                    <option value={8}>8 Hours</option>
                    <option value={9}>9 Hours</option>
                    <option value={10}>10 Hours</option>
                    <option value={11}>11 Hours</option>
                    <option value={12}>12 Hours</option>
                </select>
            </div>
            <div className="new-report-schedule-add-button-container">
                <button onClick={() =>{
                    setScheduleEntries((prevSchedules) => [...prevSchedules,{
                        frequency:scheduleFrequency,
                        time:scheduleTime,
                        inactivityThreshold:inactivityThreshold
                    }]);
                    setShowNewReportScheduleEntry(false);
                }}>Add</button>
            </div>
        </div>
    );
}
const NewInactiveDevicesReportRecipientsTab = ({recipients,setRecipients,showNewInactiveDevicesReportRecipientsTab}) =>{
    const [showNewInactiveDevicesReportNewRecipientEntry,setShowNewInactiveDevicesReportNewRecipientEntry] = useState(false);
    if(!showNewInactiveDevicesReportRecipientsTab) return null;
    return(
        <div className="new-inactive-devices-report-recipients-tab-container">
            <div className="new-inactive-devices-report-recipients-controls-container">
                <p>Recipients</p>
                <button
                    style={{display:`${showNewInactiveDevicesReportNewRecipientEntry? 'none':'inline-block'}`}}
                    onClick={() => setShowNewInactiveDevicesReportNewRecipientEntry(true)}>Add</button>
            </div>
            {recipients.length === 0? (
                <div style={{display:`${showNewInactiveDevicesReportNewRecipientEntry?'none':'block'}`}} className="new-inactive-devices-report-recipients-empty-table-container">
                    <h4>Report has no recipients</h4>
                    <p>Your report does not contain any recipients. Please add at least one recipient.</p>
                </div>):(
                <div className="new-inactive-devices-report-recipients-table-container">
                    <table>
                        <thead>
                            <tr id="new-inactive-devices-report-recipients-table-header-row">
                                <th style={{width:'20%'}}>Name</th>
                                <th style={{width:'35%'}}>Email address</th>
                                <th style={{width:'17%'}}>Date added</th>
                                <th style={{width:'17%'}}>Time added</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {recipients.length > 0 && recipients.map((recipient,recipientIndex) => (
                                <tr key={recipientIndex}>
                                    <td>{recipient.name}</td>
                                    <td>{recipient.emailAddress}</td>
                                    <td>{recipient.dateAdded}</td>
                                    <td>{recipient.timeAdded}</td>
                                    <td>
                                        <img
                                            onClick={() =>{
                                                const updatedRecipients = recipients.filter((_,index) => index !== recipientIndex);
                                                setRecipients(updatedRecipients);
                                            }}
                                            src={`${process.env.PUBLIC_URL}/images/delete-icon.png`}
                                            title="Delete recipient"/>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            <NewInactiveDevicesReportNewRecipientEntry
                recipients={recipients}
                setRecipients={setRecipients}
                showNewInactiveDevicesReportNewRecipientEntry={showNewInactiveDevicesReportNewRecipientEntry}
                setShowNewInactiveDevicesReportNewRecipientEntry={setShowNewInactiveDevicesReportNewRecipientEntry}
            />
        </div>
    );
};
const NewInactiveDevicesReportNewRecipientEntry = ({
        recipients,
        setRecipients,
        showNewInactiveDevicesReportNewRecipientEntry,
        setShowNewInactiveDevicesReportNewRecipientEntry
    }) =>{
    const [recipientName,setRecipientName] = useState('');
    const [recipientEmailAddress,setRecipientEmailAddress] = useState('');
    useEffect(() =>{
        if(showNewInactiveDevicesReportNewRecipientEntry){
            setRecipientName('');
            setRecipientEmailAddress('');
        }
    },[showNewInactiveDevicesReportNewRecipientEntry])
    if(!showNewInactiveDevicesReportNewRecipientEntry) return null;
    return(
        <div className="new-inactive-devices-report-new-recipient-entry-container">
            <div className="new-inactive-devices-report-new-recipient-entry-header">
                <h3>New recipient</h3>
                <p onClick={() => setShowNewInactiveDevicesReportNewRecipientEntry(false)}>&#10006;</p>
            </div>
            <div className="new-inactive-devices-report-new-recipient-entry-body">
                <div className="new-inactive-devices-report-new-recipient-name-container">
                    <p>Name</p>
                    <input value={recipientName} onChange={(e) => setRecipientName(e.target.value.replace(/\s/g,''))}/>
                </div>
                <div className="new-inactive-devices-report-new-recipient-email-address-container">
                    <p>Email address</p>
                    <input value={recipientEmailAddress} onChange={(e) => setRecipientEmailAddress(e.target.value.replace(/\s/g,''))}/>
                </div>
                <div className="new-inactive-devices-report-new-recipient-add-button-container">
                    <button onClick={() =>{
                        if(recipientName === '') window.alert("Enter recipient's name");
                        else if(recipientEmailAddress === '') window.alert("Enter recipient's email address");
                        else{
                            const addedDate = new Date();
                            const day = addedDate.getDate();
                            const month = addedDate.getMonth() + 1;
                            const year = addedDate.getFullYear();
                            const dateAdded = `${day > 9? '':'0'}${day}-${month > 9? '':'0'}${month}-${year}`;
                            const timeAdded = addedDate.toLocaleTimeString('en-GB');
                            setRecipients([...recipients,{
                                name:recipientName,
                                emailAddress:recipientEmailAddress,
                                dateAdded:dateAdded,
                                timeAdded:timeAdded
                            }])
                            setShowNewInactiveDevicesReportNewRecipientEntry(false);
                        }
                    }}>Add</button>
                </div>
            </div>
        </div>
    );
};
const NewInactiveDevicesReport = ({user,logout,selectedServerUrl,showNewInactiveDevicesReport,setShowNewInactiveDevicesReport}) =>{
    const {selectedTenantAdminProfile} = useContext(InactiveDevicesReportContext);
    const [showNewInactiveDevicesReportDetailsTab,setShowNewInactiveDevicesReportDetailsTab] = useState(false);
    const [showNewInactiveDevicesReportDevicesTab,setShowNewInactiveDevicesReportDevicesTab] = useState(false);
    const [showNewInactiveDevicesReportScheduleTab,setShowNewInactiveDevicesReportScheduleTab] = useState(false);
    const [showNewInactiveDevicesReportRecipientsTab,setShowNewInactiveDevicesReportRecipientsTab] = useState(false);
    const [showNewInactiveDevicesReportMessageBox,setShowNewInactiveDevicesReportMessageBox] = useState(false);
    const [newInactiveDevicesReportMessageBoxMessage,setNewInactiveDevicesReportMessageBoxMessage] = useState('');
    const [newInactiveDevicesReportMessageBoxTitle,setNewInactiveDevicesReportMessageBoxTitle] = useState('');
    const [newInactiveDevicesReportName,setNewInactiveDevicesReportName] = useState('');
    const [deviceEntries,setDeviceEntries] = useState([]);
    const [scheduleEntries,setScheduleEntries] = useState([]);
    const [recipients,setRecipients] = useState([]);
    useEffect(() => {
        if(showNewInactiveDevicesReport){
            setNewInactiveDevicesReportName('');
            setDeviceEntries([]);
            setScheduleEntries([]);
            setRecipients([]);
            setShowNewInactiveDevicesReportDevicesTab(false);
            setShowNewInactiveDevicesReportScheduleTab(false);
            setShowNewInactiveDevicesReportRecipientsTab(false);
            setShowNewInactiveDevicesReportDetailsTab(true);
        }
    },[showNewInactiveDevicesReport]);
    const createNewInactiveDevicesReport = async(report) =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/devices/inactive/reports`;
            const response = await fetch(url,{
                method:'POST',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                },
                body:JSON.stringify(report)
            });
            if(response.ok){
                ShowNewInactiveDevicesReportMessageBox('Success','Inactive devices report created successfully');
                setShowNewInactiveDevicesReport(false);
            }
            else console.error(response.status);
        }
        catch(error){
            console.error(error);
        }

    };
    const ShowNewInactiveDevicesReportMessageBox = (title,message) =>{
        setNewInactiveDevicesReportMessageBoxTitle(title);
        setNewInactiveDevicesReportMessageBoxMessage(message);
        setShowNewInactiveDevicesReportMessageBox(true);
    };
    if(!showNewInactiveDevicesReport && !showNewInactiveDevicesReportMessageBox) return null;
    return(
        <div className="new-inactive-devices-report">
            <div className="new-inactive-devices-report-header">
                <h3>Add new inactive devices report</h3>
                <p onClick={() => setShowNewInactiveDevicesReport(false)}>&#10006;</p>
            </div>
            <div className="new-inactive-devices-report-navigation-bar">
                <div className="new-inactive-devices-report-tab-navigation-bar">
                    <div className="new-inactive-devices-report-schedule-button-container">
                        <button onClick={() =>{
                            setShowNewInactiveDevicesReportDevicesTab(false);
                            setShowNewInactiveDevicesReportScheduleTab(false);
                            setShowNewInactiveDevicesReportRecipientsTab(false);
                            setShowNewInactiveDevicesReportDetailsTab(true);
                        }}
                        style={{
                            backgroundColor:`${showNewInactiveDevicesReportDetailsTab? 'rgb(169,169,169)':'white'}`
                        }}>Details</button>
                    </div>
                    <div className="new-inactive-devices-report-schedule-button-container">
                        <button onClick={() =>{
                            setShowNewInactiveDevicesReportDetailsTab(false);
                            setShowNewInactiveDevicesReportScheduleTab(false);
                            setShowNewInactiveDevicesReportRecipientsTab(false);
                            setShowNewInactiveDevicesReportDevicesTab(true);
                        }}
                        style={{
                            backgroundColor:`${showNewInactiveDevicesReportDevicesTab? 'rgb(169,169,169)':'white'}`
                        }}>Devices</button>
                    </div>
                    <div className="new-inactive-devices-report-devices-button-container">
                        <button onClick={() =>{
                            setShowNewInactiveDevicesReportDetailsTab(false);
                            setShowNewInactiveDevicesReportDevicesTab(false);
                            setShowNewInactiveDevicesReportRecipientsTab(false);
                            setShowNewInactiveDevicesReportScheduleTab(true);
                        }}
                        style={{
                            backgroundColor:`${showNewInactiveDevicesReportScheduleTab?'rgb(169,169,169)':'white'}`
                        }}>Schedule</button>
                    </div>
                    <div className="new-inactive-devices-report-recipients-button-container">
                        <button onClick={() =>{
                            setShowNewInactiveDevicesReportDetailsTab(false);
                            setShowNewInactiveDevicesReportDevicesTab(false);
                            setShowNewInactiveDevicesReportScheduleTab(false);
                            setShowNewInactiveDevicesReportRecipientsTab(true);
                        }}
                        style={{
                            backgroundColor:`${showNewInactiveDevicesReportRecipientsTab?'rgb(169,169,169)':'white'}`
                        }}>Recipients</button>
                    </div>
                </div>
                <div className="save-new-inactive-devices-report-button-container">
                    <button
                        id="save-new-inactive-devices-report-button"
                        title="Save the new inactive devices report"
                        onClick={async() =>{
                            if(newInactiveDevicesReportName === ''){
                                window.alert('Enter the name of the inactive device report');
                                return;
                            }
                            else if(deviceEntries.length === 0){
                                window.alert('At least one device is required');
                                return;
                            }
                            else if(scheduleEntries.length === 0){
                                window.alert('At least one schedule is required');
                                return;
                            }
                            else if(recipients.length === 0){
                                window.alert('At least one recipient is required');
                                return;
                            }
                            const report = {
                                name:newInactiveDevicesReportName,
                                devices:deviceEntries,
                                schedules:scheduleEntries,
                                recipients:recipients
                            };
                            await createNewInactiveDevicesReport(report);
                        }}>
                        &#10003;
                    </button>
                </div>
            </div>
            <div className="new-inactive-devices-report-body">
                <NewInactiveDevicesReportDetailsTab
                    showNewInactiveDevicesReportDetailsTab={showNewInactiveDevicesReportDetailsTab}
                    newInactiveDevicesReportName={newInactiveDevicesReportName}
                    setNewInactiveDevicesReportName={setNewInactiveDevicesReportName}
                />
                <NewInactiveDevicesReportDevicesTab
                    user={user}
                    logout={logout}
                    deviceEntries={deviceEntries}
                    setDeviceEntries={setDeviceEntries}
                    selectedServerUrl={selectedServerUrl}
                    showNewInactiveDevicesReportDevicesTab={showNewInactiveDevicesReportDevicesTab}/>
                <NewInactiveDevicesReportScheduleTab scheduleEntries={scheduleEntries} setScheduleEntries={setScheduleEntries} showNewInactiveDevicesReportScheduleTab={showNewInactiveDevicesReportScheduleTab}/>
                <NewInactiveDevicesReportRecipientsTab recipients={recipients} setRecipients={setRecipients} showNewInactiveDevicesReportRecipientsTab={showNewInactiveDevicesReportRecipientsTab}/>
                <NewInactiveDevicesReportMessageBox
                    showNewInactiveDevicesReportMessageBox={showNewInactiveDevicesReportMessageBox}
                    setShowNewInactiveDevicesReportMessageBox={setShowNewInactiveDevicesReportMessageBox}
                    title={newInactiveDevicesReportMessageBoxTitle}
                    message={newInactiveDevicesReportMessageBoxMessage}
                />
            </div>
        </div>
    );
};
export default NewInactiveDevicesReport;